export const normalizarPesquisaMateriaisVoz = (texto) => {
  let t = String(texto || "")
    .toLowerCase()
    .trim()
    .replace(/[.!?;:,]+$/g, "");

  const unidades = {
    zero: 0,
    um: 1,
    uma: 1,
    dois: 2,
    duas: 2,
    três: 3,
    tres: 3,
    quatro: 4,
    cinco: 5,
    seis: 6,
    sete: 7,
    oito: 8,
    nove: 9,
    dez: 10,
    onze: 11,
    doze: 12,
    treze: 13,
    catorze: 14,
    quatorze: 14,
    quinze: 15,
    dezasseis: 16,
    dezassete: 17,
    dezoito: 18,
    dezanove: 19,
  };

  const dezenas = {
    vinte: 20,
    trinta: 30,
    quarenta: 40,
    cinquenta: 50,
    sessenta: 60,
    setenta: 70,
    oitenta: 80,
    noventa: 90,
  };

  const numeroPorExtenso = (valor) => {
    const s = String(valor || "")
      .trim()
      .toLowerCase();

    if (/^\d+$/.test(s)) return s;

    if (Object.prototype.hasOwnProperty.call(unidades, s)) {
      return String(unidades[s]);
    }

    if (Object.prototype.hasOwnProperty.call(dezenas, s)) {
      return String(dezenas[s]);
    }

    const partes = s.split(/\s+e\s+/);

    if (
      partes.length === 2 &&
      Object.prototype.hasOwnProperty.call(dezenas, partes[0]) &&
      Object.prototype.hasOwnProperty.call(unidades, partes[1])
    ) {
      return String(dezenas[partes[0]] + unidades[partes[1]]);
    }

    return null;
  };

  const numero = String.raw`(?:\d+|zero|uma?|dois|duas|tr[eê]s|quatro|cinco|seis|sete|oito|nove|dez|onze|doze|treze|catorze|quatorze|quinze|dezasseis|dezassete|dezoito|dezanove|vinte|trinta|quarenta|cinquenta|sessenta|setenta|oitenta|noventa)(?:\s+e\s+(?:um|uma|dois|duas|tr[eê]s|quatro|cinco|seis|sete|oito|nove))?`;

  // Ex.: "zero vírgula setenta e cinco" -> "0,75".
  const decimal = new RegExp(`\\b(${numero})\\s+(?:vírgula|virgula|ponto)\\s+(${numero})\\b`, "gi");

  t = t.replace(decimal, (original, esquerda, direita) => {
    const inteiro = numeroPorExtenso(esquerda);
    const fracao = numeroPorExtenso(direita);

    if (inteiro === null || fracao === null) return original;

    const casas = /^\d+$/.test(direita.trim())
      ? direita.trim().length
      : fracao === "0"
      ? 1
      : fracao.length;

    return `${inteiro},${fracao.padStart(casas, "0")}`;
  });

  // Ex.: "trinta e três" -> "33".
  const porExtenso = new RegExp(`\\b(${numero})\\b`, "gi");

  t = t.replace(porExtenso, (original) => {
    const convertido = numeroPorExtenso(original);
    return convertido === null ? original : convertido;
  });

  // Abreviaturas comerciais.
  t = t.replace(/\bbranco\b/gi, "br");
  t = t.replace(/\btinto\b/gi, "t");

  // Expressões habituais de capacidade.
  t = t.replace(/\b(?:de\s+)?(?:(?:1|um)\s+)?litro\s+e\s+meio\b/gi, "1.5L");
  t = t.replace(/\b(?:de\s+)?meio\s+litro\b/gi, "0.5L");

  // Ex.: "0,75 litros", "1.5 litro", "2 litros" -> "0.75L", "1.5L", "2L".
  t = t.replace(
    /\b(\d+(?:[.,]\d+)?)\s*(?:litros?|l)\b/gi,
    (_, valor) => `${valor.replace(",", ".")}L`
  );

  // Ex.: "37,5 centilitros" -> "0.375L".
  t = t.replace(
    /\b(\d+(?:[.,]\d+)?)\s*(?:centilitros?|cl)\b/gi,
    (_, valor) => `${Number(valor.replace(",", ".")) / 100}L`
  );

  // Ex.: "375 mililitros" -> "0.375L".
  t = t.replace(
    /\b(\d+(?:[.,]\d+)?)\s*(?:mililitros?|ml)\b/gi,
    (_, valor) => `${Number(valor.replace(",", ".")) / 1000}L`
  );

  return t.replace(/\s+/g, " ").trim();
};
